import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';

/**
 * /sso-success page — Receives the QB JWT in the URL hash from the
 * Microsoft OAuth callback (`/api/auth/azure/callback` redirects here
 * with `#token=...`), stores it in localStorage, and navigates to the
 * dashboard. Hash is never sent to the server, so the token stays safe.
 */
const SsoSuccess = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const token = params.get('token');

    if (!token) {
      setError('No token received from Microsoft sign-in.');
      return;
    }

    localStorage.setItem('token', token);
    // Clear hash and go home
    window.history.replaceState(null, '', window.location.pathname);
    window.location.replace('/');
  }, [navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{ gap: 2 }}
    >
      {error ? (
        <Alert severity="error" sx={{ maxWidth: 480 }}>
          {error} <a href="/login">Return to login</a>
        </Alert>
      ) : (
        <>
          <CircularProgress />
          <Typography variant="body2" color="text.secondary">
            Completing sign-in…
          </Typography>
        </>
      )}
    </Box>
  );
};

export default SsoSuccess;
